<section class="m-t-12">

    <div style="text-align: center;" *ngIf="dataSource.data.length == 0">
        <h3>Sin Notas de Credito</h3>
    </div>

    <table mat-table matSort [dataSource]="dataSource" class="w-100" [ngClass]="{ 'oculto': dataSource.data.length == 0 }"
    (matSortChange)="sortTableChange($event)">
        <ng-container matColumnDef="folio">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Folio
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.folio }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="fechaDocto">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Fecha Documento
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.fechaDocto | date : 'dd-MM-yyyy'}}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="clientRut">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Rut
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.clientRut }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="clientName">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Nombre
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.clientName }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="montoExento">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Monto Exento
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.montoExento | currency : "CLP" : "symbol" }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="montoNeto">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Monto Neto
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.montoNeto | currency : "CLP" : "symbol" }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="montoIVA">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                IVA
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.montoIVA | number }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="montoTotal">
            <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                Monto Total
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.montoTotal | currency : "CLP" : "symbol"}}</h6>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row class="cursor-table" *matRowDef="let row; columns: displayColumns"></tr>
    </table>

    <mat-paginator [ngClass]="{ 'oculto': dataSource.data.length == 0 }"
    (page)="changePaginationTable($event)"
    [pageSizeOptions]="[10, 25,  50, 100]"
  ></mat-paginator>

</section>